<template>
  <v-simple-table :dense="!moreThanOneError" class="validation-errors-list">
    <template v-slot:default>
      <tbody>
      <tr v-for="(error, i) in errorList" :key="i" style="border-bottom: none;">
        <td style="border: none;">
          <span class="font-weight-bold mr-1" v-if="moreThanOneError">&bullet;</span>
          <template v-if="isParsableInteger(error)">
            <booking-validation-error :value="Number.parseInt(error, 10)"/>
          </template>
          <template v-else>{{ error }}</template>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils';
import BookingValidationError from './BookingValidationError';

export default {
  name: 'ValidationErrorsList',
  components: {BookingValidationError},
  mixins: [
    LocaleUtils,
  ],
  props: {
    errorList: {
      type: Array,
      required: true
    },
  },
  methods: {
    isParsableInteger (stringError) {
      return Number.isSafeInteger(Number.parseInt(stringError, 10));
    }
  },
  computed: {
    moreThanOneError () {
      return this.errorList && this.errorList.length > 1;
    }
  }
}
</script>
